<template>
  <SidebarComponent />
  <div class="dashboard-layout staff-ticket-mobile">
    <div class="content-container">
      <div class="card-container">
        <div class="titolo-card">
          <h1>Tickets nutrizionali aperti</h1>
        </div>
        <div class="loader" v-if="isLoading">
          <h4>RECUPERO DEI TICKETS NUTRIZIONALI IN CORSO</h4>
        </div>

        <div class="search-container staff-ticket-search">
  <input type="text" v-model="searchKeyword" placeholder="Cerca nelle conversazioni..." class="search-bar">
  <button @click="openFiltriContactModal" class="create-user-button staff-button-neutral" aria-label="Filtri ticket"><span class="material-icons">tune</span></button>
  <button @click="refreshSlot" class="create-user-button staff-button-neutral" aria-label="Aggiorna ticket"><span class="material-icons">autorenew</span></button>

  <button @click="goToAnsweredTickets" class="create-user-button staff-button-neutral">Ticket Risposti</button>

  <button @click="goToUsers" class="create-user-button2">Ricerca Utenti</button>

</div>


        <div class="tickets staff-ticket-list">
          <div>
            <table class="staff-ticket-table" role="table" aria-label="Ticket nutrizionali">
              <thead role="rowgroup">
                <tr role="row">
                  <th role="columnheader" scope="col" aria-label="Azioni"></th>
                  <th role="columnheader" scope="col">DATA</th>
                  <th role="columnheader" scope="col">STATUS</th>
                  <th role="columnheader" scope="col">STUDIO</th>
                  <th role="columnheader" scope="col">EMAIL</th>
                  <th role="columnheader" scope="col">NOME E COGNOME</th>
                  <th role="columnheader" scope="col" aria-label="Conversazione"></th>
                  <th role="columnheader" scope="col" aria-label="Messaggi"></th>
                </tr>
              </thead>
              <tbody role="rowgroup">
                <tr v-for="ticket in filteredTickets" :key="ticket.id" style="cursor: pointer;" role="row">
                  <td class="staff-ticket-actions-cell" data-label="Azioni" role="cell">
                    <div class="buttons-container">
                      <input type="checkbox" class="custom-checkbox" v-model="selectedTickets" :value="ticket.id" aria-label="Seleziona ticket">
                      <button @click.stop="deleteConversation(ticket.id)" title="Elimina Conversazione">
                        <span class="material-icons">delete</span>
                      </button>
                      <!--<button @click.stop="confirmSendNotification(ticket.userId)" title="Invia Notifica">
                        <span class="material-icons">notifications</span>
                      </button>-->
                    </div>
                  </td>
                  <td class="data-column staff-ticket-date-cell" data-label="Ultimo aggiornamento" role="cell">{{ ticket.lastUpdate }}</td>
                  <td class="data-column staff-ticket-status-cell" data-label="Stato" role="cell">
                    <select v-model="ticket.status" @change="updateTicketStatus(ticket)" aria-label="Stato ticket">
                      <option value="Aperto">Aperto</option>
                      <option value="Risposto">Risposto</option>
                      <option value="Non Risposto">Non Risposto</option>
                    </select>
                  </td>
                  <td class="staff-ticket-studio-cell" data-label="Studio" role="cell">{{ ticket.userStudio }}</td>
                  <td class="staff-ticket-email-cell" data-label="Email" role="cell">{{ ticket.userEmail }}</td>
                  <td class="staff-ticket-name-cell" data-label="Nome e cognome" role="cell">{{ ticket.userName }} {{ ticket.userSurname }}</td>
                  <td class="staff-ticket-open-cell" data-label="Conversazione" role="cell">
                    <button class="staff-ticket-open-button" aria-label="Apri conversazione" :class="{
                              'green': ticket.status === 'Risposto' && !(ticket.read === 'true' || ticket.read === true),
                              'yellow': ticket.status === 'Non Risposto' && !(ticket.read === 'true' || ticket.read === true),
                              'orange': ticket.status === 'Aperto' && !(ticket.read === 'true' || ticket.read === true),
                              'red': ticket.status === 'Completato' && !(ticket.read === 'true' || ticket.read === true),
                              'purple': ticket.read === 'true' || ticket.read === true
                            }"
                            @click.stop="viewConversation(ticket.id)">
                      <span class="staff-ticket-mobile-only">Apri conversazione</span>
                      <span class="material-icons">chevron_right</span>
                    </button>
                  </td>
                  <td class="staff-ticket-count-cell" data-label="Messaggi" role="cell">{{ ticket.conversations.length }}</td>

                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal per i filtri -->
  <div class="modal" v-if="showModal">
    <div class="modal-content">
      <span class="close" @click="closeModal">&times;</span>
      <h2>Filtri Contatto</h2>

      <select v-model="filterByStudio" @change="updateFilterByStudio">
  <option value="">Seleziona Studio</option>
  <option value="Tivoli Quartier generale">Tivoli Quartier generale</option>
  <option value="FF Genova">FF Genova</option>
  <option value="FF Bologna">FF Bologna</option>
  <option value="FF Bari">FF Bari</option>
  <option value="FF Pescara">FF Pescara</option>
  <option value="FF Firenze">FF Firenze</option>
  <option value="FF Torino">FF Torino</option>
  <option value="FF Napoli">FF Napoli</option>
  <option value="FF Milano">FF Milano</option>
  <option value="FF Milano Sempione">FF Milano Sempione</option>
  <option value="FF Milano Citta Studi">FF Milano Città Studi</option>
  <option value="FF Roma">FF Roma</option>
  <option value="FF Roma Eur">FF Roma Eur</option>
  <option value="FF Salerno">FF Salerno</option>
  <option value="FF Cagliari">FF Cagliari</option>
  <option value="FF Padova">FF Padova</option>
  <option value="undefined">Nessuno Studio</option>
</select>


      <select v-model="filterByStatus" @change="updateFilterByStatus">
        <option value="">Seleziona Status</option>
        <option value="Aperto">Aperto</option>
        <option value="Risposto">Risposto</option>
        <option value="Non Risposto">Non Risposto</option>
      </select>

      <div>
        <button @click="resetFilters" class="create-reset-button">Reset Filtri</button>
      </div>
    </div>
  </div>

  <!-- Modal per selezionare cliente e inviare messaggio -->
  <div class="modal" v-if="showModal2">
    <div class="modal-content">
      <span class="close" @click="closeClientModal">&times;</span>
      <h2>Seleziona Cliente e Invia Messaggio</h2>

      <div class="search-field">
        <input type="text" v-model="debouncedSearchClientEmail" placeholder="Cerca per email..." class="search-bar">
        <input type="text" v-model="debouncedSearchClientSurname" placeholder="Cerca per cognome..." class="search-bar">
        <button @click="onSearchClick">Cerca</button>
      </div>

      <div v-if="users.length > 0">
        <p>Clicca su un contatto per selezionarlo:</p>
        <div v-for="user in filteredUsers" :key="user.id" class="user-item" @click="selectUser(user)">
          <span>{{ user.name }} {{ user.surname }} - {{ user.email }} - {{ user.phone }}</span>
        </div>
      </div>

      <div v-if="selectedUser">
        <h3>Scrivi a {{ selectedUser.name }} {{ selectedUser.surname }}</h3>
        <input type="text" v-model="title" placeholder="Titolo del messaggio" class="message-title" />
        <textarea v-model="message" placeholder="Scrivi il tuo messaggio..." class="message-textarea"></textarea>
        <button @click="createTicket" class="send-button">Invia Messaggio</button>
      </div>
    </div>
  </div>

<!-- Modale con 5 link e testo -->
<div class="modal" v-if="showLinksModal">
  <div class="modal-content">
    <span class="close" @click="closeLinksModal">&times;</span>
    <h2>Note e link</h2>
    <p>In questa sezione possiamo posizionare link e testo, utile alle risposte:
    </p>
    <ul>
      <li>
        <a href="https://bit.ly/4baLFsa" target="_blank">Installazione app IOS</a>
        <button @click="copyToClipboard('https://bit.ly/4baLFsa')">Copia</button>
      </li>
      <li>
        <a href="https://bit.ly/4be22nU" target="_blank">Registrazione ed accesso utente</a>
        <button @click="copyToClipboard('https://bit.ly/4be22nU')">Copia</button>
      </li>
      <li>
        <a href="https://bit.ly/3XqoxCO" target="_blank">Recupera Password</a>
        <button @click="copyToClipboard('https://bit.ly/3XqoxCO')">Copia</button>
      </li>
      <li>
        <a href="https://bit.ly/3Vz0IpD" target="_blank">Apertura ticket assistenza</a>
        <button @click="copyToClipboard('https://bit.ly/3Vz0IpD')">Copia</button>
      </li>
    </ul>
  </div>
</div>


<!-- Modale per Visualizzare Statistiche -->
<div class="modal" v-if="showStatsModal">
  <div class="modal-content">
    <span class="close" @click="closeStatsModal">&times;</span>
    <h2>Statistiche Tickets</h2>
    <div>
      <p>Totale Aperto: {{ stats.aperto }}</p>
      <p>Totale Risposto: {{ stats.risposto }}</p>
      <p>Totale Non Risposto: {{ stats.nonRisposto }}</p>
    </div>
  </div>
</div>

</template>


<script>
import { useStore } from 'vuex';
import { onMounted, ref, computed, onBeforeUnmount, watch } from 'vue';
import { useRouter } from 'vue-router';
import { getFirestore, Timestamp, query, collection, where, getDocs, updateDoc, addDoc, doc, onSnapshot, deleteDoc, getDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import SidebarComponent from '../SidebarComponent.vue';
import { getFunctions, httpsCallable } from 'firebase/functions';

export default {
  components: {
    SidebarComponent
  },
  setup() {
    const currentTicketId = ref(null);
    const db = getFirestore();
    const tickets = ref([]);
    const showModal = ref(false);
    const showModal2 = ref(false);
    const showLinksModal = ref(false);
    const showStatsModal = ref(false);
    const users = ref([]);
    const selectedUser = ref(null);
    const title = ref('');
    const message = ref('');
    const searchClientEmail = ref('');
    const searchClientSurname = ref('');
    const debouncedSearchClientEmail = ref('');
    const debouncedSearchClientSurname = ref('');
    const isLoading = ref(false);
    const router = useRouter();
    const searchEmail = ref('');
    const searchSurname = ref('');
    const searchDate = ref('');
    const searchKeyword = ref('');
    const filterByMultipleTickets = ref(false);

    const stats = ref({
      aperto: 0,
      risposto: 0,
      nonRisposto: 0
    });

    const store = useStore();
    const userRole = ref(store.getters.userRole);
    const operatorStudio = ref(store.getters.userStudio);
    const filterByStatus = ref(store.getters.filterByStatus || 'Aperto');
    const filterByStudio = ref(store.getters.filterByStudio || '');
    const selectedTickets = ref([]);

    const functions = getFunctions();

    const enableDocumentUploadByDefault = async (userDocRef, userData) => {
      if (typeof userData.canUploadNutritionalFiles === 'boolean') {
        return userData;
      }

      await updateDoc(userDocRef, { canUploadNutritionalFiles: true });
      return {
        ...userData,
        canUploadNutritionalFiles: true,
      };
    };

    watch(filterByStatus, (newValue) => {
      store.dispatch('updateFilterByStatus', newValue);
    });

    watch(filterByStudio, (newValue) => {
      store.dispatch('updateFilterByStudio', newValue);
    });

    const debounce = (fn, delay) => {
      let timeoutID;
      return function (...args) {
        if (timeoutID) {
          clearTimeout(timeoutID);
        }
        timeoutID = setTimeout(() => {
          fn(...args);
        }, delay);
      };
    };

    const createTicket = async () => {
      if (!selectedUser.value || !message.value || !title.value) {
        alert("Seleziona un cliente, inserisci un titolo e scrivi un messaggio prima di inviare.");
        return;
      }

      const ticketExists = await checkExistingTicket(selectedUser.value.uid);
      if (ticketExists) {
        alert("Questo utente ha già una conversazione esistente. Non puoi creare un nuovo ticket.");
        closeClientModal();
        return;
      }

      const auth = getAuth();
      const userId = selectedUser.value.uid;
      const operatorId = auth.currentUser.uid;

      const clientTimestamp = new Date().toISOString();
      const uniqueTicketId = `TICKET-${Math.random().toString(36).substr(2, 9)}`;

      const conversations = [
        { type: 'Trainer', content: message.value, timestamp: clientTimestamp, userId: operatorId }
      ];

      const ticketData = {
        idTicket: uniqueTicketId,
        title: title.value,
        status: 'Non Risposto',
        userId: userId,
        operatorId: operatorId,
        timestamp: clientTimestamp,
        conversations: conversations
      };

      try {
        const docRef = await addDoc(collection(db, 'tickets'), ticketData);
        await enableDocumentUploadByDefault(doc(db, 'users', userId), selectedUser.value);
        await sendNotification(userId); // Invia notifica ed email per ogni utente
        console.log('Ticket creato con successo! ID:', docRef.id, 'Ticket ID:', uniqueTicketId);
        alert("Messaggio inviato con successo!");
        closeClientModal();
      } catch (error) {
        console.error('Errore nella creazione del ticket:', error);
        alert("Errore nell'invio del messaggio. Riprova.");
      }
    };

    const deleteConversation = async (ticketId) => {
      const confirmDelete = confirm("Sei sicuro di voler eliminare definitivamente questa conversazione?");
      if (confirmDelete) {
        try {
          const ticketDocRef = doc(db, 'tickets', ticketId);
          await deleteDoc(ticketDocRef);
          alert("Conversazione eliminata con successo.");
          fetchTickets();
        } catch (error) {
          console.error("Errore durante l'eliminazione della conversazione:", error);
          alert("Errore durante l'eliminazione della conversazione. Riprova.");
        }
      }
    };

    const goToAnsweredTickets = () => {
      router.push('/ticketsrisposti');
    };

    const checkExistingTicket = async (userId) => {
      const ticketsCollection = collection(db, 'tickets');
      const ticketsQuery = query(ticketsCollection, where('userId', '==', userId), where('status', 'in', ['Aperto', 'Non Risposto']));
      const ticketsSnapshot = await getDocs(ticketsQuery);
      const exists = !ticketsSnapshot.empty;
      console.log(`Ticket esistente per l'utente ${userId}: ${exists}`);
      return exists;
    };

    const selectUser = (user) => {
      selectedUser.value = user;
    };

    const fetchUsers = async () => {
      const usersCollection = collection(db, 'users');
      const userSnapshot = await getDocs(usersCollection);
      const allUsers = userSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      users.value = allUsers.filter(user => {
        const matchesEmail = debouncedSearchClientEmail.value.trim() === '' || (user.email && user.email.toLowerCase().includes(debouncedSearchClientEmail.value.toLowerCase()));
        const matchesSurname = debouncedSearchClientSurname.value.trim() === '' || (user.surname && user.surname.toLowerCase().includes(debouncedSearchClientSurname.value.toLowerCase()));
        return matchesEmail && matchesSurname;
      });
    };

    const onSearchClick = () => {
      fetchUsers();
    };

    const openClientModal = () => {
      showModal2.value = true;
    };

    const closeClientModal = () => {
      showModal2.value = false;
      selectedUser.value = null;
      title.value = '';
      message.value = '';
    };

    const openLinksModal = () => {
      showLinksModal.value = true;
    };

    const closeLinksModal = () => {
      showLinksModal.value = false;
    };

    const openStatsModal = () => {
      calculateStats();
      showStatsModal.value = true;
    };

    const closeStatsModal = () => {
      showStatsModal.value = false;
    };

    const calculateStats = () => {
      stats.value = {
        aperto: tickets.value.filter(ticket => ticket.status === 'Aperto').length,
        risposto: tickets.value.filter(ticket => ticket.status === 'Risposto').length,
        nonRisposto: tickets.value.filter(ticket => ticket.status === 'Non Risposto').length
      };
    };

    const searchByDate = async () => {
      if (searchDate.value) {
        const dayStart = new Date(searchDate.value);
        dayStart.setHours(0, 0, 0, 0);
        const dayEnd = new Date(searchDate.value);
        dayEnd.setHours(23, 59, 59, 999);

        const startTimestamp = Timestamp.fromDate(dayStart);
        const endTimestamp = Timestamp.fromDate(dayEnd);

        const ticketsQuery = query(
          collection(db, "tickets"),
          where("timestamp", ">=", startTimestamp),
          where("timestamp", "<=", endTimestamp)
        );
        const querySnapshot = await getDocs(ticketsQuery);
        tickets.value = querySnapshot.docs.map(doc => ({
          ...doc.data(),
          id: doc.id
        }));
      }
    };

    const resetSearch = () => {
      searchDate.value = '';
      fetchTickets();
    };

    const viewConversation = async (ticketId) => {
  const db = getFirestore();
  try {
    // Aggiorna il campo 'read' a true nel ticket selezionato
    await updateDoc(doc(db, 'tickets', ticketId), {
      read: true
    });
    // Poi reindirizza alla conversazione
    router.push({ name: 'AdminTicketConversation', params: { ticketId } });
  } catch (error) {
    console.error('Errore durante l\'aggiornamento del campo read:', error);
  }
};


    onBeforeUnmount(() => {
      if (currentTicketId.value) {
        const ticketDocRef = doc(db, 'tickets', currentTicketId.value);
        updateDoc(ticketDocRef, {
          status: 'Aperto'
        }).catch(error => {
          console.error("Errore nell'aggiornare lo stato del ticket:", error);
        });
      }
    });

    const goToUsers = () => {
      router.push('/users-list');
    };

    const refreshSlot = () => {
      window.location.reload();
    };

    const viewUserDetails = (userId) => {
      router.push({ name: 'UserDetails', params: { userId: userId } });
    };

    const openFiltriContactModal = () => {
      showModal.value = true;
    };

    const closeModal = () => {
      showModal.value = false;
    };

    const resetFilters = () => {
      searchEmail.value = '';
      searchSurname.value = '';
      filterByStudio.value = '';
      filterByStatus.value = '';
      store.dispatch('updateFilterByStudio', '');
      store.dispatch('updateFilterByStatus', 'Aperto');
      filterByMultipleTickets.value = false;
    };

    const fetchFilteredTickets = async () => {
      await fetchTickets();
    };

    

    const fetchTickets = async () => {
  isLoading.value = true;
  const ticketsCollection = collection(db, 'tickets');

  try {
    // Step 1: Query per monitorare i ticket con status=Aperto
    const openTicketsQuery = query(ticketsCollection, where('status', '==', 'Aperto'));

    onSnapshot(openTicketsQuery, (querySnapshot) => {
      querySnapshot.docChanges().forEach(async (change) => {
        const ticketData = change.doc.data();
        const ticketId = change.doc.id;

        // Calcola il timestamp dell'ultimo aggiornamento
        const lastUpdateTimestamp = ticketData.conversations.reduce((latest, current) => {
          const currentTimestamp = new Date(current.timestamp);
          return currentTimestamp > latest ? currentTimestamp : latest;
        }, new Date(0));
        const lastUpdateDateFormatted = `${lastUpdateTimestamp.toISOString().split('T')[0]} ${lastUpdateTimestamp.toTimeString().split(' ')[0]}`;

        if (change.type === 'added') {
          // Aggiungi il ticket alla lista
          const newTicket = {
            id: ticketId,
            ...ticketData,
            lastUpdate: lastUpdateDateFormatted,
            userEmail: 'Caricamento...', // Placeholder
            userName: 'Caricamento...',
            userSurname: '',
            userStudio: '',
          };
          tickets.value.push(newTicket);

          // Carica i dettagli dell'utente associato
          await loadUserDetailsForSingleTicket(newTicket);
        }

        if (change.type === 'modified') {
          // Aggiorna il ticket se è stato modificato
          const existingTicketIndex = tickets.value.findIndex((ticket) => ticket.id === ticketId);

          if (ticketData.status === 'Aperto') {
            if (existingTicketIndex !== -1) {
              tickets.value[existingTicketIndex] = {
                ...tickets.value[existingTicketIndex],
                ...ticketData,
                lastUpdate: lastUpdateDateFormatted,
              };
              await loadUserDetailsForSingleTicket(tickets.value[existingTicketIndex]);
            } else {
              const newTicket = {
                id: ticketId,
                ...ticketData,
                lastUpdate: lastUpdateDateFormatted,
                userEmail: 'Caricamento...', // Placeholder
                userName: 'Caricamento...',
                userSurname: '',
                userStudio: '',
              };
              tickets.value.push(newTicket);
              await loadUserDetailsForSingleTicket(newTicket);
            }
          } else {
            // Rimuovi il ticket se non è più Aperto
            if (existingTicketIndex !== -1) {
              tickets.value.splice(existingTicketIndex, 1);
            }
          }
        }

        if (change.type === 'removed') {
          // Rimuovi il ticket se è stato eliminato
          tickets.value = tickets.value.filter((ticket) => ticket.id !== ticketId);
        }
      });

      // Ordina i ticket per data (nuovi in alto)
      tickets.value.sort((a, b) => new Date(b.lastUpdate) - new Date(a.lastUpdate));

      isLoading.value = false;
    });
  } catch (error) {
    console.error('Errore nel caricamento dei ticket:', error);
    isLoading.value = false;
  }
};




const loadUserDetailsForSingleTicket = async (ticket) => {
  const usersCollection = collection(db, 'users');
  try {
    const userDocRef = doc(usersCollection, ticket.userId);
    const userDoc = await getDoc(userDocRef);
    if (userDoc.exists()) {
      const userData = await enableDocumentUploadByDefault(userDocRef, userDoc.data());

      // Aggiorna il ticket con i dettagli dell'utente
      const updatedTicketIndex = tickets.value.findIndex((t) => t.id === ticket.id);
      if (updatedTicketIndex !== -1) {
        tickets.value[updatedTicketIndex] = {
          ...tickets.value[updatedTicketIndex],
          userEmail: userData.email || 'Email sconosciuta',
          userName: userData.name || 'Nome sconosciuto',
          userSurname: userData.surname || 'Cognome sconosciuto',
          userStudio: userData.studio || 'Studio sconosciuto',
        };
      }
    }
  } catch (error) {
    console.error(`Errore nel caricamento dei dettagli per il ticket ${ticket.id}:`, error);
  }
};







const fetchUserDetails = async () => {
  const usersCollection = collection(db, 'users');
  try {
    const userSnapshot = await getDocs(usersCollection);
    const userDetails = {};

    userSnapshot.forEach(doc => {
      const userData = doc.data();
      userDetails[doc.id] = {
        email: userData.email,
        name: userData.name,
        surname: userData.surname,
        studio: userData.studio,
        uid: userData.uid,
      };
    });

    return userDetails;
  } catch (error) {
    console.error('Errore nel recupero dei dettagli utente:', error);
    return {};
  }
};



    const confirmSendNotification = async (userId) => {
      const confirmSend = confirm("Sei sicuro di voler inviare una notifica?");
      if (confirmSend) {
        sendNotification(userId);
      }
    };

    const confirmSendNotificationsToSelected = async () => {
      const confirmSend = confirm("Sei sicuro di voler inviare notifiche agli utenti selezionati?");
      if (confirmSend) {
        sendNotificationsToSelected();
      }
    };

    const sendNotificationsToSelected = async () => {
      for (const ticketId of selectedTickets.value) {
        const ticket = tickets.value.find(t => t.id === ticketId);
        if (ticket) {
          try {
            await sendNotification(ticket.userId);
          } catch (error) {
            console.error(`Errore durante l'invio della notifica per l'utente ${ticket.userId}:`, error);
          }
        }
      }
      alert('Notifiche inviate con successo!');
      selectedTickets.value = [];
    };

    const sendNotification = async (userId) => {
      try {
        const sendNotificationFunction = httpsCallable(functions, 'sendNotificationAndEmail');
        await sendNotificationFunction({ userId, notificationType: 'nutrizionale' });
        console.log('Notifica inviata con successo per l\'utente:', userId);
      } catch (error) {
        console.error('Errore durante l\'invio della notifica:', error);
      }
    };

    const updateTicketStatus = async (ticket) => {
      try {
        const ticketDocRef = doc(db, 'tickets', ticket.id);
        await updateDoc(ticketDocRef, { status: ticket.status });
        alert('Stato del ticket aggiornato con successo!');
      } catch (error) {
        console.error('Errore durante l\'aggiornamento dello stato del ticket:', error);
        alert('Errore durante l\'aggiornamento dello stato del ticket. Riprova.');
      }
    };

    const selectAllVisibleTickets = () => {
      selectedTickets.value = filteredTickets.value.map(ticket => ticket.id);
    };

    const confirmDeleteSelectedTickets = async () => {
      const confirmDelete = confirm("Sei sicuro di voler eliminare i ticket selezionati?");
      if (confirmDelete) {
        await deleteSelectedTickets();
      }
    };

    const deleteSelectedTickets = async () => {
      try {
        const deletePromises = selectedTickets.value.map(ticketId => deleteDoc(doc(db, 'tickets', ticketId)));
        await Promise.all(deletePromises);
        alert("I ticket selezionati sono stati eliminati con successo.");
        selectedTickets.value = [];
        fetchTickets();
      } catch (error) {
        console.error("Errore durante l'eliminazione dei ticket selezionati:", error);
        alert("Errore durante l'eliminazione dei ticket selezionati. Riprova.");
      }
    };

    const filteredTickets = computed(() => {
      const userTicketCounts = tickets.value.reduce((acc, ticket) => {
        acc[ticket.userId] = (acc[ticket.userId] || 0) + 1;
        return acc;
      }, {});

      const filteredList = tickets.value.filter((ticket) => {
        const matchesEmail = searchEmail.value ? (ticket.userEmail && ticket.userEmail.toLowerCase().includes(searchEmail.value.toLowerCase())) : true;
        const matchesSurname = searchSurname.value ? (ticket.userSurname && ticket.userSurname.toLowerCase().includes(searchSurname.value.toLowerCase())) : true;
        const matchesStudio = filterByStudio.value === 'undefined' ? 
                              (!ticket.userStudio || ticket.userStudio === 'undefined') :
                              filterByStudio.value ? ticket.userStudio === filterByStudio.value : true;
        const matchesStatus = filterByStatus.value ? 
          filterByStatus.value === 'Non Risposto' ? 
          ticket.status === 'Non Risposto' :
            filterByStatus.value === 'Aperto' ?
              ticket.status === 'Aperto' :
              filterByStatus.value === 'Risposto' ?
                ticket.status === 'Risposto' :
                true :
          true;
        const matchesMultipleTickets = filterByMultipleTickets.value ? userTicketCounts[ticket.userId] > 1 : true;
        const matchesKeyword = searchKeyword.value ? ticket.conversations.some(convo => convo.content.toLowerCase().includes(searchKeyword.value.toLowerCase())) : true;
        return matchesEmail && matchesSurname && matchesStudio && matchesStatus && matchesMultipleTickets && matchesKeyword;
      });

      const groupedByUser = filteredList.reduce((acc, ticket) => {
        if (!acc[ticket.userId]) {
          acc[ticket.userId] = [];
        }
        acc[ticket.userId].push(ticket);
        return acc;
      }, {});

      return Object.values(groupedByUser).flat();
    });

    const filteredUsers = computed(() => {
      return users.value.filter((user) => {
        const matchesEmail = user.email && user.email.toLowerCase().includes(debouncedSearchClientEmail.value.toLowerCase());
        const matchesSurname = user.surname && user.surname.toLowerCase().includes(debouncedSearchClientSurname.value.toLowerCase());
        return matchesEmail && matchesSurname;
      });
    });

    onMounted(fetchTickets);

    watch([searchClientEmail, searchClientSurname], debounce(() => {
      debouncedSearchClientEmail.value = searchClientEmail.value;
      debouncedSearchClientSurname.value = searchClientSurname.value;
      fetchUsers();
    }, 500));

    return {
      tickets,
      viewConversation,
      selectedTypes: ref({}),
      isLoading,
      filteredTickets,
      resetFilters,
      fetchFilteredTickets,
      searchEmail,
      searchSurname,
      filterByStudio,
      filterByStatus,
      filterByMultipleTickets,
      searchKeyword,
      openFiltriContactModal,
      closeModal,
      showModal,
      showModal2,
      openClientModal,
      closeClientModal,
      showLinksModal,
      openLinksModal,
      closeLinksModal,
      showStatsModal,
      openStatsModal,
      closeStatsModal,
      stats,
      calculateStats,
      users,
      selectedUser,
      title,
      message,
      viewUserDetails,
      refreshSlot,
      searchDate,
      searchByDate,
      resetSearch,
      fetchUsers,
      selectUser,
      createTicket,
      checkExistingTicket,
      searchClientEmail,
      searchClientSurname,
      debouncedSearchClientEmail,
      debouncedSearchClientSurname,
      filteredUsers,
      operatorStudio,
      userRole,
      onSearchClick,
      deleteConversation,
      confirmSendNotification,
      confirmSendNotificationsToSelected,
      selectedTickets,
      sendNotificationsToSelected,
      updateTicketStatus,
      selectAllVisibleTickets,
      confirmDeleteSelectedTickets,
      deleteSelectedTickets,
      goToUsers,
      fetchUserDetails,
      goToAnsweredTickets
    };
  },
};
</script>




<style scoped>

.create-user-button2 {
  padding: 13px 15px;
  border-radius: 13px;
  background-color: #f2a100;
  color: white;
  font-size: 1rem;
  cursor: pointer;
  border: none;
  text-align: center; /* Centra il testo orizzontalmente */
  display: inline-flex; /* Assicura che l'allineamento al centro funzioni correttamente */
  align-items: center; /* Centra verticalmente il contenuto */
  justify-content: center; /* Centra orizzontalmente il contenuto */
}
.data-column {
  width: 400px;
  font-size: 12px;
}

/* Stili esistenti */
.buttons-container {
  display: flex;
  gap: 10px; /* Spazio tra i bottoni */
  align-items: center; /* Allinea gli elementi verticalmente al centro */
}

.buttons-container button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
}

/* Stili per i checkbox */
.custom-checkbox {
  width: 20px;  /* Larghezza del checkbox */
  height: 20px; /* Altezza del checkbox */
  margin: 0;    /* Margine */
  cursor: pointer; /* Cursor pointer per l'interazione */
}

.custom-checkbox:checked {
  background-color: #4CAF50; /* Colore di sfondo quando è selezionato */
  border: 2px solid #4CAF50; /* Bordo quando è selezionato */
}

.custom-checkbox:focus {
  outline: none; /* Rimuove il bordo di messa a fuoco */
}


</style>

<style scoped src="../../assets/css/staff-ticket-mobile.css"></style>
